import React, {CSSProperties} from "react";
import {observer} from "mobx-react";

export interface ContentProps {
  pageName?: string | JSX.Element,
  wrapperCss?: CSSProperties,
  onHeaderClick?: () => void
  pageBodyClasses?: string
}

@observer
export default class Page extends React.Component<ContentProps> {
  render() {
    return <div className={"content-container"} style={{height: "100%"}}>
      {this.props.pageName ? <h1 className={"content-header"}>{this.props.pageName}</h1> : <></>}
      <div className={"page-body" + (this.props.pageBodyClasses ? " " + this.props.pageBodyClasses : "")}>
        {this.props.children}
      </div>
    </div>
  }
}
